const events = {
	FRAME_RESIZE: 'FRAME_RESIZE', // Sends { height }
	SIGNIN_START: 'SIGNIN_START',
	SIGNIN_MALFORMED: 'SIGNIN_MALFORMED', // Sends { messages }
	SIGNIN_INVALID_CREDENTIALS: 'SIGNIN_INVALID_CREDENTIALS',
	SIGNIN_ACCOUNT_LOCKED: 'SIGNIN_ACCOUNT_LOCKED',
	SIGNIN_NETWORK_ERROR: 'SIGNIN_NETWORK_ERROR',
	SIGNIN_SERVER_ERROR: 'SIGNIN_SERVER_ERROR',
	SIGNIN_MULTI_ACCOUNT: 'SIGNIN_MULTI_ACCOUNT', // Sends { email }
	SIGNIN_MULTI_ACCOUNT_SELECTED: 'SIGNIN_MULTI_ACCOUNT_SELECTED',
	SIGNIN_FACEBOOK_ERROR: 'SIGNIN_FACEBOOK_ERROR',
	SIGNIN_COMPLETE: 'SIGNIN_COMPLETE', // Sends { userId, type }
	MFA_START: 'MFA_START',
	MFA_CODE_MALFORMED: 'MFA_CODE_MALFORMED',
	MFA_NETWORK_ERROR: 'MFA_NETWORK_ERROR',
	MFA_SERVER_ERROR: 'MFA_SERVER_ERROR',
	MFA_CODE_INVALID: 'MFA_CODE_INVALID',
	MFA_CODE_EXPIRED: 'MFA_CODE_EXPIRED',
	RECOVERY_CODE_START: 'RECOVERY_CODE_START',
	RECOVERY_CODE_MALFORMED: 'RECOVERY_CODE_MALFORMED',
	RECOVERY_CODE_NETWORK_ERROR: 'RECOVERY_CODE_NETWORK_ERROR',
	RECOVERY_CODE_SERVER_ERROR: 'RECOVERY_CODE_SERVER_ERROR',
	RECOVERY_CODE_INVALID: 'RECOVERY_CODE_INVALID',
	RECOVERY_CODE_COMPLETE: 'RECOVERY_CODE_COMPLETE', // Sends { userId }
	RECOVERY_CODE_EXPIRED_CREDENTIALS: 'RECOVERY_CODE_EXPIRED_CREDENTIALS',
	PASSWORD_RESET_START: 'PASSWORD_RESET_START',
	PASSWORD_RESET_NETWORK_ERROR: 'PASSWORD_RESET_NETWORK_ERROR',
	PASSWORD_RESET_SERVER_ERROR: 'PASSWORD_RESET_SERVER_ERROR',
	PASSWORD_RESET_EMAIL_MALFORMED: 'PASSWORD_RESET_EMAIL_MALFORMED',
	PASSWORD_RESET_EMAIL_SENT: 'PASSWORD_RESET_EMAIL_SENT',
	PASSWORD_RESET_SENT: 'PASSWORD_RESET_SENT',
	PASSWORD_RESET_CODE_EXPIRED: 'PASSWORD_RESET_CODE_EXPIRED',
	PASSWORD_RESET_CODE_MALFORMED: 'PASSWORD_RESET_CODE_MALFORMED',
	PASSWORD_RESET_CODE_INVALID: 'PASSWORD_RESET_CODE_INVALID',
	PASSWORD_RESET_CODE_VALID: 'PASSWORD_RESET_CODE_VALID',
	PASSWORD_RESET_CODE_VALID_MULTI_ACCOUNT: 'PASSWORD_RESET_CODE_VALID_MULTI_ACCOUNT',
	PASSWORD_RESET_MULTI_ACCOUNT_SELECTED: 'PASSWORD_RESET_MULTI_ACCOUNT_SELECTED',
	PASSWORD_RESET_PASSWORD_MALFORMED: 'PASSWORD_RESET_PASSWORD_MALFORMED',
	PASSWORD_RESET_PASSWORD_MISMATCH: 'PASSWORD_RESET_PASSWORD_MISMATCH',
	PASSWORD_RESET_PASSWORD_SAVED: 'PASSWORD_RESET_PASSWORD_SAVED'
};

export default events;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/events.js